<mat-toolbar class="toolbar-single">
  <div class="header-group">
    <button
      mat-icon-button
      class="menu-toggle"
      (click)="toggleSidenav()"
      *ngIf="isMobile && !hideSidenav"
    >
      <mat-icon>menu</mat-icon>
    </button>

    <div class="page">
      <button
        *ngIf="header?.locationBack"
        class="mr-2"
        mat-icon-button
        (click)="goBack()"
      >
        <mat-icon>arrow_back</mat-icon>
      </button>

      <div class="page-info" [class.page-info--centered]="header?.showDownload || header?.centered">
        <ng-container *ngIf="!header?.loading; else headerLoading">
          <div class="page-title-row">
            <h1>{{ header?.title || "Dashboard" }}</h1>

           <button
              *ngIf="header?.showDownload"
              class="download-btn"
              mat-icon-button
              matTooltip="Baixar documentos do fornecedor"
              (click)="onAction()"
              [disabled]="header?.downloadLoading"
            >
              <mat-spinner *ngIf="header?.downloadLoading; else downloadIcon" diameter="20"></mat-spinner>
              <ng-template #downloadIcon>
                <mat-icon>download</mat-icon>
              </ng-template>
            </button>

          </div>
          <span *ngIf="header?.subtitle" class="subtitle">{{ header?.subtitle }}</span>
        </ng-container>
        <ng-template #headerLoading>
          <div class="page-title-row">
            <ngx-skeleton-loader
              count="1"
              appearance="line"
              [theme]="{
                height: '24px',
                width: '200px',
                'border-radius': '4px',
                margin: '0'
              }"
            ></ngx-skeleton-loader>
            <ngx-skeleton-loader
              *ngIf="header?.showDownload"
              count="1"
              appearance="circle"
              [theme]="{
                width: '36px',
                height: '36px',
                margin: '0'
              }"
            ></ngx-skeleton-loader>
          </div>
        </ng-template>
      </div>
    </div>

    <div class="user-actions-container">
      <app-messages></app-messages>
      <button mat-icon-button [matMenuTriggerFor]="menu">
        <div class="user-initials">
          {{ avatar }}
        </div>
      </button>
    </div>

    <mat-menu #menu="matMenu">
      <button mat-menu-item disabled class="text-truncate user-name-item">
        Olá, {{ userName }}
      </button>

      <button mat-menu-item [routerLink]="['/configuracao']">
        <mat-icon>settings</mat-icon>
        <span>Configuração</span>
      </button>

      <button mat-menu-item (click)="changePassword()">
        <mat-icon>password</mat-icon>
        <span>Alterar minha senha</span>
      </button>

      <!-- <button mat-menu-item (click)="goToServiceDesk()">
        <mat-icon>help_center</mat-icon>
        <span>Preciso de ajuda</span>
      </button> -->

      <button mat-menu-item (click)="logout()">
        <mat-icon>exit_to_app</mat-icon>
        <span>Sair</span>
      </button>
    </mat-menu>
  </div>
</mat-toolbar>
